import circle from "./type/circle";
import window from "./type/window";
import skeleton from "./type/skeleton";
export default {
    circle: circle,
    window: window,
    skeleton: skeleton
};
